import { z } from 'zod';

// The cookie banner (UK PECR): essential cookies (sign-in, security) are always on; analytics only after the
// player accepts. The super admin edits the text and the categories; raising the version asks everyone again.
export const ConsentSettings = z
  .object({
    enabled: z.boolean(),
    message: z.string().trim().min(20).max(400),
    analyticsEnabled: z.boolean(),
    version: z.number().int().min(1),
  })
  .strict();
export type ConsentSettings = z.infer<typeof ConsentSettings>;
export const DEFAULT_CONSENT_SETTINGS: ConsentSettings = {
  enabled: true,
  message:
    'We use essential cookies to keep you signed in and safe. With your OK we also count visits, so we can make the game better. No ad trackers.',
  analyticsEnabled: true,
  version: 1,
};
export const ConsentSettingsReply = z.object({ consent: ConsentSettings });
export type ConsentSettingsReply = z.infer<typeof ConsentSettingsReply>;
// the admin saves the settings; askAgain raises the version so every player sees the banner again
export const ConsentSettingsUpdate = ConsentSettings.omit({ version: true }).extend({ askAgain: z.boolean() }).strict();
export type ConsentSettingsUpdate = z.infer<typeof ConsentSettingsUpdate>;

// what a player chose, kept in their browser
export const ConsentChoice = z.object({ version: z.number().int(), analytics: z.boolean(), at: z.string() });
export type ConsentChoice = z.infer<typeof ConsentChoice>;
